<template>
    <!-- SECTION: Template -->
    <div class="sub-page">
        <!-- ANCHOR: PageTitle -->
        <PageTitle
            main-title="도입부터 발행까지"
            sub-title="즉시 도입 가능한 오픈배지 플랫폼"
            bg-color="blue9"
        />

        <!-- ANCHOR: Step -->
        <section class="c-section bg-blue9 d-flex justify-center">
            <div class="c-contanier">
                <div
                    class="d-flex flex-column step-wrap"
                    :class="{ 'gap-12': $vuetify.breakpoint.mdAndUp, 'gap-10': $vuetify.breakpoint.smAndDown }"
                >
                    <!-- 계약 진행 -->
                    <div
                        class="d-flex"
                        :class="{ 'flex-column': $vuetify.breakpoint.xsOnly }"
                    >
                        <div class="step-title le-heading6 text-white1 d-flex align-center justify-center">
                            Step 01
                        </div>

                        <v-card 
                            class="d-flex flex-grow-1"
                            :class="{
                                'pt-15 pb-15 pl-10 pr-10': $vuetify.breakpoint.mdAndUp,
                                'pt-10 pb-10 pl-5 pr-5': $vuetify.breakpoint.smOnly,
                                'pt-10 pb-8 pl-3 pr-3': $vuetify.breakpoint.xsOnly,
                            }"
                        >
                            <div 
                                class="d-flex align-center justify-center"
                                :class="{
                                    'mr-10': $vuetify.breakpoint.mdAndUp,
                                    'mr-5': $vuetify.breakpoint.smOnly,
                                    'mr-3': $vuetify.breakpoint.xsOnly,
                                }"
                            >
                                <v-img
                                    :src="require('@/assets/img/issuance-step-1.png')"
                                    :width="$vuetify.breakpoint.mdAndUp ? 104 : ($vuetify.breakpoint.smAndDown ? 80 : 80)"
                                    :height="$vuetify.breakpoint.mdAndUp ? 88 : ($vuetify.breakpoint.smAndDown ? 68 : 68)"
                                    alt=""
                                />
                            </div>

                            <div>
                                <p
                                    class="le-heading5 text-blue3"
                                    :class="{ 'mb-5': $vuetify.breakpoint.mdAndUp, 'mb-4': $vuetify.breakpoint.smOnly, 'mb-3': $vuetify.breakpoint.xsOnly }"
                                >
                                    계약 진행
                                </p>

                                <div class="d-flex flex-column gap-3">
                                    <p class="le-text-body1">
                                        발행인 등록을 위한 내용 협의 후 계약 진행
                                    </p>
                                </div>
                            </div>
                        </v-card>
                    </div>

                    <!-- 기본 설정 -->
                    <div
                        class="d-flex"
                        :class="{ 'flex-column': $vuetify.breakpoint.xsOnly }"
                    >
                        <div class="step-title le-heading6 text-white1 d-flex align-center justify-center">
                            Step 02
                        </div>

                        <v-card 
                            class="d-flex flex-grow-1"
                            :class="{
                                'pt-15 pb-15 pl-10 pr-10': $vuetify.breakpoint.mdAndUp,
                                'pt-10 pb-10 pl-5 pr-5': $vuetify.breakpoint.smOnly,
                                'pt-10 pb-8 pl-3 pr-3': $vuetify.breakpoint.xsOnly,
                            }"
                        >
                            <div 
                                class="d-flex align-center justify-center"
                                :class="{
                                    'mr-10': $vuetify.breakpoint.mdAndUp,
                                    'mr-5': $vuetify.breakpoint.smOnly,
                                    'mr-3': $vuetify.breakpoint.xsOnly,
                                }"
                            >
                                <v-img
                                    :src="require('@/assets/img/issuance-step-2.png')"
                                    :width="$vuetify.breakpoint.mdAndUp ? 104 : ($vuetify.breakpoint.smAndDown ? 80 : 80)"
                                    :height="$vuetify.breakpoint.mdAndUp ? 88 : ($vuetify.breakpoint.smAndDown ? 68 : 68)"
                                    alt=""
                                />
                            </div>

                            <div>
                                <p
                                    class="le-heading5 text-blue3"
                                    :class="{ 'mb-5': $vuetify.breakpoint.mdAndUp, 'mb-4': $vuetify.breakpoint.smOnly, 'mb-3': $vuetify.breakpoint.xsOnly }"
                                >
                                    기본 설정
                                </p>

                                <div class="d-flex flex-column gap-3">
                                    <p class="le-text-body1">
                                        발행인 등록 후 오픈배지 시스템 관리자 설정
                                    </p>
                                </div>
                            </div>
                        </v-card>
                    </div>

                    <!-- 발행 준비 -->
                    <div
                        class="d-flex"
                        :class="{ 'flex-column': $vuetify.breakpoint.xsOnly }"
                    >
                        <div class="step-title le-heading6 text-white1 d-flex align-center justify-center">
                            Step 03
                        </div>

                        <v-card 
                            class="d-flex flex-grow-1"
                            :class="{
                                'pt-15 pb-15 pl-10 pr-10': $vuetify.breakpoint.mdAndUp,
                                'pt-10 pb-10 pl-5 pr-5': $vuetify.breakpoint.smOnly,
                                'pt-10 pb-8 pl-3 pr-3': $vuetify.breakpoint.xsOnly,
                            }"
                        >
                            <div 
                                class="d-flex align-center justify-center"
                                :class="{
                                    'mr-10': $vuetify.breakpoint.mdAndUp,
                                    'mr-5': $vuetify.breakpoint.smOnly,
                                    'mr-3': $vuetify.breakpoint.xsOnly,
                                }"
                            >
                                <v-img
                                    :src="require('@/assets/img/issuance-step-3.png')"
                                    :width="$vuetify.breakpoint.mdAndUp ? 104 : ($vuetify.breakpoint.smAndDown ? 80 : 80)"
                                    :height="$vuetify.breakpoint.mdAndUp ? 88 : ($vuetify.breakpoint.smAndDown ? 68 : 68)"
                                    alt=""
                                />
                            </div>

                            <div>
                                <p
                                    class="le-heading5 text-blue3"
                                    :class="{ 'mb-5': $vuetify.breakpoint.mdAndUp, 'mb-4': $vuetify.breakpoint.smOnly, 'mb-3': $vuetify.breakpoint.xsOnly }"
                                >
                                    발행 준비
                                </p>

                                <div class="d-flex flex-column gap-3">
                                    <p class="le-text-body1">
                                        배지 디자인과 배지에 들어가는 데이터 준비
                                    </p>

                                    <p class="le-text-body1">
                                        발행 전용 사이트에서 배지 정보 및 수령인 등록
                                    </p>
                                </div>
                            </div>
                        </v-card>
                    </div>

                    <!-- 배지 발행 -->
                    <div
                        class="d-flex"
                        :class="{ 'flex-column': $vuetify.breakpoint.xsOnly }"
                    >
                        <div class="step-title le-heading6 text-white1 d-flex align-center justify-center">
                            Step 04
                        </div>

                        <v-card 
                            class="d-flex flex-grow-1"
                            :class="{
                                'pt-15 pb-15 pl-10 pr-10': $vuetify.breakpoint.mdAndUp,
                                'pt-10 pb-10 pl-5 pr-5': $vuetify.breakpoint.smOnly,
                                'pt-10 pb-8 pl-3 pr-3': $vuetify.breakpoint.xsOnly,
                            }"
                        >
                            <div 
                                class="d-flex align-center justify-center"
                                :class="{
                                    'mr-10': $vuetify.breakpoint.mdAndUp,
                                    'mr-5': $vuetify.breakpoint.smOnly,
                                    'mr-3': $vuetify.breakpoint.xsOnly,
                                }"
                            >
                                <v-img
                                    :src="require('@/assets/img/issuance-step-4.png')"
                                    :width="$vuetify.breakpoint.mdAndUp ? 104 : ($vuetify.breakpoint.smAndDown ? 80 : 80)"
                                    :height="$vuetify.breakpoint.mdAndUp ? 88 : ($vuetify.breakpoint.smAndDown ? 68 : 68)"
                                    alt=""
                                />
                            </div>

                            <div>
                                <p
                                    class="le-heading5 text-blue3"
                                    :class="{ 'mb-5': $vuetify.breakpoint.mdAndUp, 'mb-4': $vuetify.breakpoint.smOnly, 'mb-3': $vuetify.breakpoint.xsOnly }"
                                >
                                    배지 발행
                                </p>

                                <div class="d-flex flex-column gap-3">
                                    <p class="le-text-body1">
                                        수여 대상자에게 수여 알림 메일 자동 전송
                                    </p>

                                    <p class="le-text-body1">
                                        수령인은 메일을 통해 계정을 생성하고 배지를 수령
                                    </p>
                                </div>
                            </div>
                        </v-card>
                    </div>
                </div>
            </div>
        </section>

        <!-- ANCHOR: 비용 문의 -->
        <section class="c-section d-flex justify-center">
            <div class="c-contanier">
                <h2 class="text-center le-heading3 c-title">
                    도입 항목 및 비용은 문의해주세요.
                </h2>

                <div class="d-flex justify-center">
                    <v-btn
                        :to="{ name: 'ContactPage' }"
                        color="orange1"
                        depressed
                        :large="$vuetify.breakpoint.mdAndUp"
                        class="text-white1"
                    >
                        비용 문의
                    </v-btn>
                </div>

                <div
                    style="max-width: 995px;"
                    class="d-flex justify-center flex-wrap mx-auto"
                    :class="{
                        'gap-12 mt-20': $vuetify.breakpoint.mdAndUp,
                        'gap-10 mt-10': $vuetify.breakpoint.smAndDown
                    }"
                >
                    <v-card
                        color="blue6"
                        :class="{ 'pa-12': $vuetify.breakpoint.mdAndUp, 'pa-9': $vuetify.breakpoint.smOnly, 'pa-7': $vuetify.breakpoint.xsOnly }"
                        :style="{
                            'width': $vuetify.breakpoint.mdAndUp ? '470px' : $vuetify.breakpoint.smOnly ? '380px' : '100%',
                            'max-width': $vuetify.breakpoint.xsOnly ? '360px' : ''
                        }"
                    >
                        <div class="d-flex">
                            <div :class="{ 'mr-10': $vuetify.breakpoint.mdAndUp, 'mr-8': $vuetify.breakpoint.smAndDown }">
                                <p class="le-heading5">
                                    기본 사항
                                </p>

                                <v-img
                                    :src="require('@/assets/img/issuance-cost-1.png')"
                                    :width="$vuetify.breakpoint.mdAndUp ? 136 : ($vuetify.breakpoint.smAndDown ? 76 : 76)"
                                    :height="$vuetify.breakpoint.mdAndUp ? 136 : ($vuetify.breakpoint.smAndDown ? 76 : 76)"
                                    alt=""
                                />
                            </div>

                            <div class="le-text-body1 mt-1">
                                무제한 배지 등록<br>
                                무제한 수여자 등록<br>
                                배지 대량 발행 가능<br>
                                PDF 인증서 기능<br>
                                블록체인 기록<br>
                                <span class="le-text-body3 text-gray3">*Block Cert 사용</span>
                            </div>
                        </div>
                    </v-card>

                    <v-card
                        color="orange2"
                        :class="{ 'pa-12': $vuetify.breakpoint.mdAndUp, 'pa-9': $vuetify.breakpoint.smOnly, 'pa-7': $vuetify.breakpoint.xsOnly }"
                        :style="{
                            'width': $vuetify.breakpoint.mdAndUp ? '470px' : $vuetify.breakpoint.smOnly ? '380px' : '100%',
                            'max-width': $vuetify.breakpoint.xsOnly ? '360px' : ''
                        }"
                    >
                        <div class="d-flex">
                            <div :class="{ 'mr-10': $vuetify.breakpoint.mdAndUp, 'mr-8': $vuetify.breakpoint.smAndDown }">
                                <p class="le-heading5 white-space-nowrap">
                                    선택 사항
                                </p>

                                <v-img
                                    :src="require('@/assets/img/issuance-cost-2.png')"
                                    :width="$vuetify.breakpoint.mdAndUp ? 136 : ($vuetify.breakpoint.smAndDown ? 76 : 76)"
                                    :height="$vuetify.breakpoint.mdAndUp ? 136 : ($vuetify.breakpoint.smAndDown ? 76 : 76)"
                                    alt=""
                                />
                            </div>

                            <div class="le-text-body1 mt-1">
                                배지 디자인 의뢰<br>
                                API 설정 비용<br>
                                <span class="le-text-body3 text-gray3">*고객사 연동은 발행자 직접 진행</span><br>
                                구체적인 배지 컨설팅<br>
                            </div>
                        </div>
                    </v-card>
                </div>
            </div>
        </section>
    </div>
    <!-- !SECTION: Template -->
</template>

<script>
import { getIssuanceMetaInfo } from '@/utils/metaInfo.js';
import PageTitle from '@/components/PageTitle.vue';

export default {
    name: 'IssuancePage',
    components: {
        PageTitle
    },

    metaInfo() {
        return getIssuanceMetaInfo(this);
    },

    // SECTION: Data Properties
    data: function () {
        return {
            //
        };
    },
    // !SECTION: Data Properties

    // SECTION: Lifecycle Hooks
    created() {
        //
    },

    mounted() {
        //
    },

    beforeDestroy() {
        //
    },
    // !SECTION: Lifecycle Hooks

    // SECTION: Methods
    methods: {
        /* ============================================================
         * ANCHOR: 주석
         * ============================================================ */
        //
    },
    // !SECTION: Methods
};
</script>
